(function(api) {
	api.RadnikByOib = RadnikByOib;
	api.GetIbanRadnika = GetIbanRadnika;
	api.GetZahtjevSFields = GetZahtjevSFields;
	api.ZahtjevSObrisi = ZahtjevSObrisi;
	api.GetPovijestSFields = GetPovijestSFields;
	api.ProvjeriSalda = ProvjeriSalda;
	api.SetStatusZahtjeva = SetStatusZahtjeva;
	api.ValidatePrezimeZaNI = ValidatePrezimeZaNI;
	api.GetKnjigaNaslov = GetKnjigaNaslov;
	api.GetStanjeZOsobaNaslov = GetStanjeZOsobaNaslov;
	api.GetStanjeZOsobaOpcije = GetStanjeZOsobaOpcije;
	api.GetDnevnikZOsobaNaslov = GetDnevnikZOsobaNaslov;
	api.GetDnevnikZOsobaOpcije = GetDnevnikZOsobaOpcije;
	api.DajValutuZaDatumIsplate = DajValutuZaDatumIsplate;
	
	function RadnikByOib(oib){
		return $.dsDirectCall({
			method: "RadnikByOib",
			params: [ oib ]
		});
	}
	
	function GetIbanRadnika(radnik){
		return $.dsDirectCall({
			method: "GetIbanRadnika",
			params: [ radnik ]
		});
	}
	
	function GetZahtjevSFields(){
		return $.dsDirectCall({
			method: "GetZahtjevSFields"
		});
	}
	
	function ZahtjevSObrisi(zahtjevs){
		return $.dsDirectCall({
			method: "ZahtjevSObrisi",
			params: [ zahtjevs ]
		});
	}
	
	function GetPovijestSFields(){
		return $.dsDirectCall({
			method: "GetPovijestSFields"
		});
	}
	
	function ProvjeriSalda(zahtjev, javiGresku){
		if (javiGresku == undefined) javiGresku = false;
		return $.dsDirectCall({
			method: "ProvjeriSalda",
			params: [ zahtjev ]
		});
	}
	
	function SetStatusZahtjeva(zahtjev, status, poruka){
		return $.dsDirectCall({
			method: "SetStatusZahtjeva",
			params: [ zahtjev, status, poruka ]
		});
	}
		
	function ValidatePrezimeZaNI(prezime){
		return $.dsDirectCall({
			method: "ValidatePrezimeZaNI",
			params: [ prezime ]
		});
	}

	function GetKnjigaNaslov(tip){
		return $.dsDirectCall({
			method: "GetKnjigaNaslov",
			params: [ tip ]
		});
	}
	
	function GetStanjeZOsobaNaslov(tip){
		return $.dsDirectCall({
			method: "GetStanjeZOsobaNaslov",
			params: [ tip ]
		});
	}
	
	function GetStanjeZOsobaOpcije(tip){
		return $.dsDirectCall({
			method: "GetStanjeZOsobaOpcije",
			params: [ tip ]
		});
	}

	function GetDnevnikZOsobaNaslov(tip){
		return $.dsDirectCall({
			method: "GetDnevnikZOsobaNaslov",
			params: [ tip ]
		});
	}
	
	function GetDnevnikZOsobaOpcije(tip){
		return $.dsDirectCall({
			method: "GetDnevnikZOsobaOpcije",
			params: [ tip ]
		});
	}
	
	function DajValutuZaDatumIsplate(dtDatumIsplate){
		return $.dsDirectCall({
			method: "DajValutuZaDatumIsplate",
			params: [ dtDatumIsplate ]
		});
	}


} (konto.ni.api = {}));